import React from 'react';
import styled, { css } from 'styled-components';

import { palette } from '../../constants/styles';
import Icon from './Icon';
import Logo from './Logo';
import PoliglotLink from '../PoliglotLink';
import { poliglotLink } from '../../classes/poliglotlink';

import Text from './Text';
import { mq, co, flexcolumn, flexrow } from '../../styles/theme';
import { useState } from 'react';

export const NAV_HEIGHT_MOBILE = 50;
export const NAV_HEIGHT_DESKTOP = 80;

const options = [
  {
    text: 'Calculadora de retiro',
    link: new poliglotLink('/retiro', false, true),
  },
  {
    text: 'Plan de pensión',
    link: new poliglotLink('https://www.finauta.com/plan-de-pension', false, false),
  },
  {
    text: 'Guía de pensión',
    link: new poliglotLink('https://www.finauta.com/pension-imss', false, false),
  },
  {
    text: 'Conócenos',
    link: new poliglotLink('/conocenos', false, true),
  },
];

const StyledHeader = styled.div`
  position: fixed;
  ${({ sales }) => sales && 'position: absolute;'}
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: white;
  width: 100%;
  z-index: 1000000;
  height: ${NAV_HEIGHT_MOBILE}px;
  top: 0px;

  ${mq.md} {
    height: ${NAV_HEIGHT_DESKTOP}px;
    border-bottom: 2px solid ${co.gray1};
  }
`;

const MobileNavWrapper = styled.div`
  display: block;
  ${mq.md} {
    display: none;
  }
`;

const MobileOptionsWrapper = styled.div`
  ${flexcolumn};
  max-height: ${({ open }) => (open ? '500px' : '0px')};
  width: 100%;
  transition: max-height 0.5s ease-out;
  overflow: hidden;
  position: absolute;
  background-color: white;
  z-index: 100;
  top: ${NAV_HEIGHT_MOBILE}px;
  left: 0px;
  justify-content: flex-start;
  align-items: flex-start;
  border-bottom: 2px solid ${co.gray1};

  ${mq.md} {
    top: ${NAV_HEIGHT_DESKTOP}px;
  }
`;

const StyledSeparation = styled.div`
  width: 90%;
  height: 1px;
  border-bottom: 1px solid ${co.gray1};
  margin-left: auto;
  margin-right: auto;
`;

const MobileOption = styled.div`
  ${flexrow};
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const StyledMobileOption = css`
  color: ${palette.terciaryColor};
  ${flexrow};
  width: 93%;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

const StyledDesktopOption = css`
  cursor: pointer;
  width: fit-content;
  text-align: center;
  line-height: 1.25;
  padding: 10px;
  font-size: 1.2rem;
`;

const TakeUpSpace = styled.div`
  width: 100%;
  height: ${NAV_HEIGHT_MOBILE}px;
  ${mq.md} {
    height: ${NAV_HEIGHT_DESKTOP}px;
  }
`;

const DesktopNavWrapper = styled.div`
  display: none;
  ${mq.md} {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
`;

const OptionsWrapper = styled.div`
  ${({ sales }) => sales && 'display:none;'}
  ${mq.md} {
    flex-grow: 1;
    max-width: 60%;
  }
  ${mq.lg} {
    max-width: 70%;
  }
`;

const OptionSeparator = styled.div`
  height: ${NAV_HEIGHT_DESKTOP * 0.7}px;
  width: 1px;
  background-color: ${co.accentColor};

  ${mq.lg} {
    height: ${NAV_HEIGHT_DESKTOP * 0.4}px;
  }
`;

const NavBar = ({ sales = false }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return (
    <>
      <TakeUpSpace />
      <StyledHeader sales={sales}>
        <Logo />
        <OptionsWrapper sales={sales}>
          <DesktopNavWrapper>
            {options.map(({ text, link }, idx) => {
              const options_length = options.length - 1;
              return (
                <>
                  <PoliglotLink to={link}>
                    <Text
                      styles={StyledDesktopOption}
                      color={palette.terciaryColor}
                      medium
                      marginless
                    >
                      {text}
                    </Text>
                  </PoliglotLink>
                  {idx < options_length && <OptionSeparator />}
                </>
              );
            })}
          </DesktopNavWrapper>
          <MobileNavWrapper>
            <a
              onClick={() => {
                setMobileMenuOpen(!mobileMenuOpen);
              }}
            >
              {mobileMenuOpen ? (
                <Icon icon="cross" color={palette.basicGray} size={30} style={{ margin: '10px' }} />
              ) : (
                <Icon
                  icon="hamburguer"
                  color={palette.primaryColor}
                  size={30}
                  style={{ margin: '10px' }}
                />
              )}
            </a>
            <MobileOptionsWrapper open={mobileMenuOpen}>
              {options.map(({ text, link }) => (
                <>
                  <StyledSeparation />
                  <MobileOption>
                    <PoliglotLink width="100%" to={link}>
                      <Text
                        styles={StyledMobileOption}
                        style={{ fontSize: '1.5rem' }}
                        medium
                        marginless
                      >
                        <span style={{ color: palette.terciaryColor }}>{text}</span>
                        <Icon
                          icon="sweetArrow"
                          color={palette.terciaryColor}
                          size={20}
                          style={{ marginLeft: '10px' }}
                        />
                      </Text>
                    </PoliglotLink>
                  </MobileOption>
                </>
              ))}
            </MobileOptionsWrapper>
          </MobileNavWrapper>
        </OptionsWrapper>
      </StyledHeader>
    </>
  );
};
export default NavBar;
